import React, {useEffect, useState} from "react";
import axios from "axios";

export default function BrandAssetsCategory() {
  const [totalCount, setTotalCount] = useState(0);
  const [list, setList] = useState([]);

  const [data, setData] = useState({
    categoryId: '',
    title: '',
    subTitle: '',
    description: '',
    activeStatus: 'Y',
  });

  const [videoData, setVideoData] = useState({
    videoLink: '',
    fileDisplayName: '',
    thumbnail: null,
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value
    });
  };

  const handleVideoInputChange = (e: any) => {
    const { name, value, type, files } = e.target;

    if (type === 'file') {
      // 파일 입력인 경우 files[0]을 저장
      setVideoData({
        ...videoData,
        thumbnail: files[0]
      });
    } else {
      // 일반 텍스트 입력인 경우
      setVideoData({
        ...videoData,
        [name]: value
      });
    }
  };

  async function getList() {
    axios({
      method: 'get',
      url: 'https://en.finevu.com/api/controller/admin/brand-assets/getBrandAssetList.php?categoryId=&keyword&sortColumn=ca&sortOrder=desc'
    }).then(function (response) {
      setList(response.data.list);
      setTotalCount(response.data.totalCnt);
    });
  }

  useEffect(() => {
    getList();
  }, []);

  const handleChange = (id: any, status: string) => {
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/updActiveStatus.php", {
      ID: id,
      activeStatus: status === 'Y' ? 'N' : 'Y',
    }).then(function (response) {
      if (response?.data?.result) {
        alert(response?.data?.msg);
        getList();
      } else {
        alert(response?.data?.msg);
      }
    });
  }

  const [modal, setModal] = useState({
    visible: false,
    id: '',
  });

  useEffect(() => {
    if(modal.id !== '') {
      getBrandAssetDetail();
    } else {
      setData({
        categoryId: '',
        title: '',
        subTitle: '',
        description: '',
        activeStatus: 'Y',
      });
    }
  }, [modal.id]);

  async function getBrandAssetDetail() {
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/getBrandAssetDetail.php", {
      ID: modal.id,
    }).then(function (response) {
      if (response?.data?.result) {
        const res = response.data.detail;
        setData({
          categoryId: res.categoryIdx || '',
          title: res.title || '',
          subTitle: res.subTitle || '',
          description: res.description || '',
          activeStatus: res.activeStatus || 'Y',
        });
      } else {
        alert(response?.data?.msg);
      }
    });
  }

  async function setBrandAsset(id: any) {
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/setBrandAsset.php", {
      ID: id,
      ...data
    }).then(function (response) {
      if (response?.data?.result) {
        alert(response?.data?.msg);
        setModal({ visible: false, id: '' }); // 모달 닫기
        getList();
      } else {
        alert(response?.data?.msg);
      }
    });
  }

  const [categoryList, setCategoryList] = useState([]);
  function getAssetCategoryList() {
    axios({
      method: 'get',
      url: 'https://en.finevu.com/api/controller/admin/brand-assets/asset-categories/getAssetCategoryList.php?sortColumn=categoryName&sortOrder=desc'
    }).then(function (response) {
      setCategoryList(response.data.list);
    });
  }
  useEffect(() => {
    getAssetCategoryList();
  }, []);


  const [listModal, setListModal] = useState({
    visible: false,
    id: 0,
  });


  const [registration, setRegistration] = useState({
    visible: false,
    id: '',
    catId: 0
  });


  async function setAssetFiles(id: string, catId: number) {
    const formData = new FormData();
    formData.append('assetId', id);
    formData.append('catId', catId.toString());

    // 이미지 여러 장 처리
    if (catId !== 2) {
      selectedFiles.forEach((file) => {
        formData.append('files[]', file); // PHP 서버에서 $_FILES['files'] 배열로 받음
      });
    } else {
      // 영상인 경우 기존 로직 유지
      formData.append('videoLink', videoData.videoLink);
      formData.append('fileDisplayName', videoData.fileDisplayName);
      if (videoData.thumbnail) formData.append('thumbnail', videoData.thumbnail);
    }

    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/asset-files/setAssetFiles.php", formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(function (response) {
      if (response?.data?.result) {
        alert(response?.data?.msg);
        setRegistration({ visible: false, id: '', catId: 0 });
        setSelectedFiles([]); // 성공 후 초기화
        getList();
      } else {
        alert(response?.data?.msg);
      }
    });
  }




  // 컴포넌트 내부에 추가
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isDragging, setIsDragging] = useState(false);

// 드래그 영역에 진입/유지 시
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };

// 드래그 영역에서 벗어날 때
  const handleDragLeave = () => {
    setIsDragging(false);
  };

// 파일을 드롭했을 때
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0) {
      setSelectedFiles((prev) => [...prev, ...files]);
    }
  };

// 파일 선택 버튼을 통한 처리
  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = Array.from(e.target.files);
      setSelectedFiles((prev) => [...prev, ...files]);
    }
  };

// 선택된 파일 삭제 (리스트에서 제거)
  const removeFile = (index: number) => {
    setSelectedFiles(selectedFiles.filter((_, i) => i !== index));
  };


  const [fileList, setFileList] = useState([]);
  const [catId, setCatId] = useState();
  async function getAssetFileList(id: any, catId: any) {
    setCatId(catId);
    axios.post("https://en.finevu.com/api/controller/admin/brand-assets/asset-files/getAssetFileList.php", {
      assetId: id,
      categoryId: catId,
    }).then(function (response) {
      if (response?.data?.result) {
        setFileList(response?.data?.list);
        setListModal({visible: true, id: id});
      } else {
        alert(response?.data?.msg);
      }
    });
  }

  async function delAssetFile(fileId: number, assetId: any, categoryId: any) {
    const isConfirm = window.confirm("정말 삭제 하시겠습니까? \n삭제 이후에는 복구할 수 없습니다.");
    if (isConfirm) {
      axios.post("https://en.finevu.com/api/controller/admin/brand-assets/asset-files/delAssetFile.php", {
        fileId: fileId,
      }).then(function (response) {
        if (response?.data?.result) {
          alert(response?.data?.msg || '삭제되었습니다.');
          getAssetFileList(assetId, categoryId);
        } else {
          alert(response?.data?.msg);
        }
      });
    }
  }

  return (
    <>
      <div className="contentBox administrator">
        <h3>Setting</h3>
        <div className="flexWrap">
          <div className="flexBox">
            <h4>
              Brand Assets 카테고리 관리
              <span className="content_count">{totalCount}</span>
            </h4>
            <button className="addBtn" onClick={() => setModal({visible: true, id: ''})}>
              <i className="fa-solid fa-plus"></i>
              <span>Add New</span>
            </button>
          </div>
          {/*<div className="search_box">
            <input type="text" ref={searchRef} placeholder="Search ..." defaultValue={keyword} onKeyDown={handleEnter}/>
            <button type="button" className="ic-button" onClick={handleSearch}>
              <img src="/assets/images/searchBox.png" alt="검색아이콘"/>
            </button>
          </div>*/}
        </div>

        <table className="table_hover">
          <thead>
          <tr>
            <th>
              <span className="sortWrap">
                  카테고리
              </span>
            </th>
            <th>
              <span className="sortWrap">
                  제목(제품명)
              </span>
            </th>
            <th>
              <span className="sortWrap">
                등록일
              </span>
            </th>
            <th>
              <span className="sortWrap">
                상태
              </span>
            </th>
            <th>
              <span className="sortWrap">
                  관리(정보/파일보기/업로드)
              </span>
            </th>
          </tr>
          </thead>
          <tbody>
          {list?.map((list: any, index: number) => (
            <tr key={index}>
              <td>{list.categoryName}</td>
              <td>{list.title}</td>
              <td>{list.createdDate}</td>
              <td>
                <span className="toggleSwitch">
                    <input type="checkbox" id={`member_statUs_${list.ID}`} className="toggleIpt" hidden checked={list?.activeStatus === 'Y' ? true : false} onChange={() => handleChange(list?.ID, list?.activeStatus)}/>
                    <label htmlFor={`member_statUs_${list.ID}`} className="toggleSwitch">
                        <span className="toggleButton"></span>
                    </label>
                </span>
              </td>
              <td>
                <button onClick={() => setModal({visible: true, id: list.ID})} className="blueBtn">수정</button>
                &nbsp;
                <button onClick={() => getAssetFileList(list.ID, list.categoryIdx)} className="blueBtn">목록보기</button>
                &nbsp;
                <button onClick={() => setRegistration({visible: true, id: list.ID, catId: list.categoryIdx})} className="blueBtn">등록</button>

                {/*{list?.categoryId === '' && ()}*/}
                {/*<button onClick={() => setModal({visible: true, id: list.ID})}>수정</button>
                <button onClick={() => setModal({visible: true, id: list.ID})}>파일보기</button>
                <button onClick={() => setModal({visible: true, id: list.ID})}>파일업로드</button>*/}
              </td>
            </tr>
          ))}
          </tbody>
        </table>
      </div>

      {modal.visible && (
        <div className="modal">
          <div>
            <h2>{modal.id === '' ? '기본 정보 등록' : '기본 정보 수정'}</h2>
            <div>
              <table>
                <tbody>
                <tr>
                  <td>
                    <label htmlFor="categoryId">카테고리</label>
                    <select id="categoryId" name="categoryId" onChange={handleInputChange} value={data.categoryId}>
                      <option value="" disabled>카테고리를 선택하세요</option>
                      {categoryList?.map((cat: any) => (
                        cat.activeStatus === 'Y' && (
                          <option key={cat.ID} value={cat.ID}>
                            {cat.categoryName}
                          </option>
                        )
                      ))}
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="title">제목</label>
                    <input type="text" name="title" id="title" onChange={handleInputChange} value={data.title}/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="title">서브 타이틀</label>
                    <input type="text" name="subTitle" id="subTitle" onChange={handleInputChange} value={data.subTitle}/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="description">상세 설명</label>
                    <textarea onChange={handleInputChange} value={data.description} id="description" name="description" rows={5} style={{border: '1px solid #E9E9E9', resize: 'none', width: '100%'}}/>
                  </td>
                </tr>
                <tr>
                  <td className="radio">
                    <p style={{marginBottom: '10px'}}>노출 상태</p>
                    <label htmlFor="activeStatus1">사용 (노출)</label>
                    <input
                      type="radio"
                      value="Y"
                      name="activeStatus"
                      id="activeStatus1"
                      checked={data.activeStatus === 'Y'}
                      onChange={handleInputChange}
                    />
                    <label htmlFor="activeStatus2">미사용 (숨김)</label>
                    <input
                      type="radio"
                      value="N"
                      name="activeStatus"
                      id="activeStatus2"
                      checked={data.activeStatus === 'N'}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="footer">
              <button className="close-button" onClick={() => setModal({visible: false, id: ''})}>취소</button>
              <button className="registration-button" onClick={() => setBrandAsset(modal.id || 0)}>{modal.id === '' ? '등록' : '수정'}하기</button>
            </div>
            <button className="close" onClick={() => setModal({visible: false, id: ''})}>X</button>
          </div>
        </div>
      )}

      {/* 파일 목록 */}
      {listModal.visible && (
        <div className="modal file-list-modal">
          <div>
            <h2>{catId === 2 ? '영상' : '파일'} 목록</h2>
            <ul className="file-list">
              {catId === 2 ? (
                <>
                  {fileList && fileList.map((item: any, index: number) => (
                    <li key={index}>
                      <div>
                        <img src={`https://en.finevu.com/${item?.thumbPath}`} alt=""/>
                        <a href={item?.videoLink} target="_blank">{item?.videoLink}</a>
                      </div>
                      <button className='redBtn' onClick={() => delAssetFile(item?.fileId, item?.assetId, item.categoryId)}>삭제</button>
                    </li>
                  ))}
                </>
              ) : (
                <>
                  {fileList && fileList.map((item: any, index: number) => (
                    <li key={index}>
                      <div>
                        <img src={item?.filePath} alt=""/>
                        <a href={item?.filePath} target="_blank">{item?.originalFileName}</a>
                      </div>
                      <button className='redBtn' onClick={() => delAssetFile(item?.fileId, item?.assetId, item.categoryId)}>삭제</button>
                    </li>
                  ))}
                </>
              )}
              {/*<ul>
                {fileList && fileList.map((item: any, index: number) => (
                  <li key={index}></li>
                ))}
              </ul>*/}
            </ul>
            <div className="footer">
            <button className="close-button" onClick={() => setListModal({visible: false, id: 0})}>닫기</button>
            </div>
            <button className="close" onClick={() => setListModal({visible: false, id: 0})}>X</button>
          </div>
        </div>
      )}

      {/*영상 등록*/}
      {registration.visible && registration.catId === 2 && (
        <div className="modal">
          <div>
            <h2>영상 등록</h2>
            <div>
              <table>
                <tbody>
                <tr>
                  <td>
                    <label htmlFor="fileDisplayName">영상 타이틀 (목록 노출용)</label>
                    <input type="text" name="fileDisplayName" id="fileDisplayName" onChange={handleVideoInputChange}/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="title">다운로드 링크</label>
                    <input type="text" name="videoLink" id="videoLink" onChange={handleVideoInputChange}/>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label htmlFor="thumbnail">영상 썸네일 등록</label>
                    <input type="file" id="thumbnail" name="thumbnail" onChange={handleVideoInputChange} accept="image/*"/>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div className="footer">
              <button className="close-button" onClick={() => setRegistration({visible: false, id: '', catId: 0})}>취소</button>
              <button className="registration-button" onClick={() => setAssetFiles(registration.id, registration.catId)}>등록하기</button>
            </div>
            <button className="close" onClick={() => setRegistration({visible: false, id: '', catId: 0})}>X</button>
          </div>
        </div>
      )}


      {/*이미지 등록*/}
      {registration.visible && registration.catId !== 2 && (
        <div className="modal">
          <div>
            <h2>파일 업로드</h2>
            <div style={{padding: '20px'}}>
              <div
                className={`drop-zone ${isDragging ? 'active' : ''}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  border: '2px dashed #ccc',
                  borderRadius: '10px',
                  padding: '40px',
                  textAlign: 'center',
                  backgroundColor: isDragging ? '#f0f8ff' : '#fff',
                  cursor: 'pointer'
                }}
                onClick={() => document.getElementById('fileInput')?.click()}
              >
                <p>파일을 이 곳으로 드래그하거나 클릭하여 선택하세요.</p>
                <input
                  type="file"
                  id="fileInput"
                  multiple
                  hidden
                  onChange={handleFileSelect}
                  accept="image/*"
                />
              </div>

              {/* 선택된 파일 목록 미리보기 */}
              <div className="file-list" style={{marginTop: '20px', maxHeight: '200px', overflowY: 'auto'}}>
                {selectedFiles.map((file: any, index: number) => (
                  <div key={index} style={{display: 'flex', justifyContent: 'space-between', padding: '5px', borderBottom: '1px solid #eee'}}>
                    <span>{file.name} ({(file.size / 1024).toFixed(1)} KB)</span>
                    <button onClick={() => removeFile(index)} style={{color: 'red', border: 'none', background: 'none', cursor: 'pointer'}}>삭제</button>
                  </div>
                ))}
              </div>
            </div>
            <div className="footer">
              <button className="close-button" onClick={() => setRegistration({visible: false, id: '', catId: 0})}>닫기</button>
              <button className="registration-button" onClick={() => setAssetFiles(registration.id, registration.catId)}>선택 파일 업로드</button>
            </div>
            <button className="close" onClick={() => setRegistration({visible: false, id: '', catId: 0})}>X</button>
          </div>
        </div>
      )}
    </>
  )
}
